import { MessageType } from '@connect-x-app/shared-domain-models';

interface MessageTypeInfo {
  translationKey: string | null;
}

export const getMessageTypeTranslationKey = (messageType: MessageType | string | undefined | null): MessageTypeInfo => ({
  translationKey: messageType ? `SYSTEM_MESSAGES.MESSAGE_TYPES.${messageType}` : null,
});
